export const environment = {
    hmr: false,
    production: true,
    version: '3.5.5.287',
};
